module.exports = __webpack_public_path__ + "static/media/male4.f76860f9.png";